import { type FC } from 'react';
import type { Number3 } from '../types';
import { useAbyssViewerContext } from './AbyssViewerContext';

export interface WireframeBoxProps {
  position: Number3 | undefined;
  rotation: Number3 | undefined;
  scale: Number3;
  color: number;
  lineWidth?: number;
}

export const WireframeBox: FC<WireframeBoxProps> = ({
  position,
  rotation,
  scale,
  color,
  lineWidth,
}) => {
  const { sharedGeometries } = useAbyssViewerContext();
  const { cuboidLines } = sharedGeometries ?? {};

  return (
    cuboidLines && (
      <lineSegments position={position} rotation={rotation} scale={scale} geometry={cuboidLines}>
        <lineBasicMaterial color={color} linewidth={lineWidth} attach="material" />
      </lineSegments>
    )
  );
};
